<template>
  <div class="instantwin_message_history">
    <message-history :campaign="campaign"></message-history>
  </div>
</template>

<script lang="ts">
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import MessageHistory from '@/client/features/twitter_instantwin_message_history/message_history'
import { useNavbarStore } from '@/client/store/useNavbarStore'
import { useSystemStore } from '@/client/store/useSystemStore'
import { useTwitterInstantwinMessageHistoryStore } from '@/client/store/useTwitterInstantwinMessageHistoryStore'
import { TCampaign } from '@/typings/api/campaigns.type'

export default defineComponent({
  components: {
    MessageHistory
  },
  computed: {
    ...mapState(useSystemStore, {
      currentGroupId: state => state.currentGroup?.id ?? null
    }),
    ...mapState(useTwitterInstantwinMessageHistoryStore, {
      campaign: state => {
        if (state.campaign) {
          return state.campaign
        }
        return {}
      }
    })
  },
  async mounted() {
    const params = {
      campaignId: Number(this.$route.params.campaignId)
    }

    this.setHistoryParams(params)
    this.fetchMessages(params)

    await this.fetchCampaign()

    const campaign: Partial<TCampaign> = this.campaign
    if (campaign.id && campaign.groupId !== undefined && this.currentGroupId !== campaign.groupId) {
      this.setCurrentGroup(campaign.groupId)
    }

    this.setBreadcrumb([
      {
        name: 'キャンペーン一覧',
        link: '/campaigns',
        iconUrl: null,
        iconType: null
      },
      {
        name: campaign.title ?? '',
        link: `/twitter_instantwins/${campaign.id}`,
        iconName: campaign.account ? campaign.account.name : '削除されたアカウント',
        iconUrl: campaign.account ? campaign.account.pictureUrl : null,
        iconType: campaign.snsType,
        label: campaign.type === 'instantwin' ? 'インスタントウィン' : null,
        isIcon: true
      }
    ])
  },

  methods: {
    ...mapActions(useSystemStore, ['setCurrentGroup']),
    ...mapActions(useNavbarStore, ['setBreadcrumb']),
    ...mapActions(useTwitterInstantwinMessageHistoryStore, [
      'resetMessageHistory',
      'fetchCampaign',
      'fetchMessages',
      'setHistoryParams'
    ])
  },

  beforeRouteLeave(to: any, from: any, next: any) {
    // 応募者ストアをリセット
    this.resetMessageHistory()
    next()
  }
})
</script>
